import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { Box, Button, CircularProgress, Paper, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import DropDown from "./DropDown";
import Footer from "./Footer";
import PaginationRounded from "./PaginationRounded";
import ShowPosts from "./ShowPosts";

const PAGE_SIZE = 12;
const initialFilter = { area: "הכל​", profession: "הכל​" };

export default function EndedBidsPage() {
  const [posts, setPosts] = useState([]);
  const [filter, setFilter] = useState(initialFilter);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.React_APP_BACKEND_URL}/api/allbids`, {
        headers: { Authorization: `Bearer ${Cookies.get("token") || ""}` },
      })
      .then((response) => {
        const ended = (response.data?.Bids || []).filter(
          (post) => post.showbid !== "no" && Number(post.deadline) <= Date.now()
        );
        setPosts(ended);
      })
      .finally(() => setLoading(false));
  }, []);

  const filteredPosts = useMemo(
    () => posts
      .filter((post) => filter.area === "הכל​" || filter.area.toString().includes(post.area?.toString() || ""))
      .filter((post) => filter.profession === "הכל​" || (post.skills?.toString() || "").includes(filter.profession.toString())),
    [posts, filter]
  );

  const updateFilter = (nextFilter) => {
    setFilter(nextFilter);
    setPage(1);
  };

  return (
    <Box sx={{ minHeight: "100dvh", background: "linear-gradient(180deg,#F7FAFD 0%,#FFFFFF 45%,#F8FBFE 100%)" }}>
      <Box dir="rtl" sx={{ width: "100%", maxWidth: 1280, mx: "auto", px: { xs: 1.25, sm: 2.5, md: 3 }, py: { xs: 2, md: 3.5 }, boxSizing: "border-box" }}>
        <Button component={NavLink} to="/" startIcon={<ArrowForwardRoundedIcon />} sx={{ mb: 1.5, fontFamily: "Assistant", fontWeight: 800, textTransform: "none", "& .MuiButton-startIcon": { ml: 0.6, mr: 0 } }}>
          חזרה לדף הבית
        </Button>

        <Typography component="h1" sx={{ fontFamily: "Assistant", fontWeight: 900, color: "#173B57", fontSize: { xs: 27, md: 36 } }}>
          מכרזים שהסתיימו
        </Typography>
        <Typography sx={{ mt: 0.4, mb: 2.3, fontFamily: "Assistant", color: "#667F91", fontSize: { xs: 14.5, md: 16 } }}>
          כאן ניתן לצפות במכרזים האחרונים שהסתיימו ב-Bidit.
        </Typography>

        <Paper elevation={0} sx={{ mb: 2.5, p: { xs: 1.2, sm: 1.5 }, borderRadius: "18px", border: "1px solid #E2ECF4", boxShadow: "0 8px 24px rgba(22,58,86,.06)" }}>
          <DropDown setFilter={updateFilter} filter={filter} />
        </Paper>

        {loading ? (
          <Box sx={{ py: 8, textAlign: "center" }}><CircularProgress /></Box>
        ) : filteredPosts.length > 0 ? (
          <>
            <ShowPosts showPosts={filteredPosts} page={page} pageSize={PAGE_SIZE} filter={initialFilter} what="closed" search1="no" />
            {filteredPosts.length > PAGE_SIZE && (
              <PaginationRounded handleChange={(_, value) => { setPage(value); window.scrollTo({ top: 0, behavior: "smooth" }); }} page={page} count={Math.ceil(filteredPosts.length / PAGE_SIZE)} />
            )}
          </>
        ) : (
          <Paper elevation={0} sx={{ py: 6, px: 2, textAlign: "center", borderRadius: "20px", border: "1px solid #E2ECF4" }}>
            <Typography sx={{ fontFamily: "Assistant", fontWeight: 800, color: "#315B77" }}>
              לא נמצאו מכרזים שהסתיימו בהתאם לסינון שבחרתם.
            </Typography>
          </Paper>
        )}
      </Box>
      <Footer />
    </Box>
  );
}
